/* Cart-drawer "Popular right now" slider behaviour.
   Loaded ONCE and uses event delegation on document so it keeps working after the cart drawer
   re-renders via the Section Rendering API (add-to-cart / delete) — an inline <script> inside the
   re-rendered HTML would NOT execute (browsers don't run scripts inserted via innerHTML), which is
   why arrows + the add button went dead after the first AJAX cart update. */
(function () {
  if (window.__fsCartPopularInit) return;
  window.__fsCartPopularInit = true;

  function trackFor(el) {
    var pop = el.closest('.fs-cart-popular');
    return pop ? pop.querySelector('.fs-cart-popular__track') : null;
  }

  /* Update every cart-count badge (header bubble + mobile sticky toolbar + drawer header).
     /cart/add.js doesn't return the cart total, so fetch /cart.js for item_count. Coalesced so
     rapid events (PDP add fires several) don't spam the network. */
  var _countTimer = null;
  function updateCartCounts() {
    if (_countTimer) return;
    _countTimer = setTimeout(function () {
      _countTimer = null;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var n = cart.item_count;
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = n < 100 ? n : (window.cartStrings && window.cartStrings.item_99) || '99+';
          });
          document.querySelectorAll('[data-cart-text]').forEach(function (el) {
            if (!el.closest('.drawer__inner-empty')) el.textContent = '(' + n + ')';
          });
          document.querySelectorAll('.cart-count-bubble').forEach(function (b) {
            if (n > 0) b.removeAttribute('hidden');
          });
        })
        .catch(function () {});
    }, 60);
  }
  window.fsUpdateCartCounts = updateCartCounts;

  /* Custom scroll indicator for the cart items list — iOS Safari hides the native scrollbar, so
     this JS thumb makes the "list scrolls" cue visible on every device. */
  function setupScrollbar() {
    var wrap = document.querySelector('#CartDrawer .drawer__cart-items-wrapper');
    if (!wrap) return;
    var host = wrap.parentElement; /* #CartDrawer-CartItems */
    if (!host) return;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var bar = host.querySelector(':scope > .fs-scrollbar');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'fs-scrollbar';
      bar.innerHTML = '<div class="fs-scrollbar__thumb"></div>';
      host.appendChild(bar);
    }
    var thumb = bar.querySelector('.fs-scrollbar__thumb');
    function update() {
      var scrollable = wrap.scrollHeight - wrap.clientHeight;
      if (scrollable <= 4) { bar.classList.remove('is-active'); return; }
      bar.classList.add('is-active');
      /* align the indicator track to the visible items area */
      var top = wrap.offsetTop, h = wrap.clientHeight;
      bar.style.top = (top + 4) + 'px';
      bar.style.height = (h - 8) + 'px';
      var trackH = h - 8;
      var thumbH = Math.max(28, trackH * (wrap.clientHeight / wrap.scrollHeight));
      var maxThumbTravel = trackH - thumbH;
      var t = (wrap.scrollTop / scrollable) * maxThumbTravel;
      thumb.style.height = thumbH + 'px';
      thumb.style.top = t + 'px';
    }
    wrap.addEventListener('scroll', update, { passive: true });
    update();
    /* keep it correct when the cart re-renders / resizes */
    if (window.ResizeObserver) {
      try { new ResizeObserver(update).observe(wrap); } catch (e) {}
    }
    wrap._fsScrollUpdate = update;
  }
  function refreshScrollbar() { setTimeout(setupScrollbar, 60); }

  /* Catch-all: any cart change re-renders #CartDrawer. Observe it and refresh counts — this catches
     the PDP add (product-form.js renderContents) that previously left the bottom toolbar badge stale. */
  function observeDrawer() {
    var cd = document.getElementById('CartDrawer');
    if (!cd) { setTimeout(observeDrawer, 500); return; }
    var mo = new MutationObserver(function () { updateCartCounts(); refreshScrollbar(); });
    mo.observe(cd, { childList: true, subtree: true });
  }
  observeDrawer();
  refreshScrollbar();

  function scrollByCards(track, dir) {
    var card = track.querySelector('.fs-cart-popular__card');
    var w = card ? card.offsetWidth + 12 : 160;
    track.scrollBy({ left: dir * w * 2, behavior: 'smooth' });
  }

  function updateArrows(track) {
    var pop = track.closest('.fs-cart-popular');
    if (!pop) return;
    var prev = pop.querySelector('.fs-cart-popular__arrow--prev');
    var next = pop.querySelector('.fs-cart-popular__arrow--next');
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
  }

  /* arrows — delegated click (clicks bubble, so this survives re-render) */
  document.addEventListener('click', function (e) {
    var prevBtn = e.target.closest('.fs-cart-popular__arrow--prev');
    var nextBtn = e.target.closest('.fs-cart-popular__arrow--next');
    if (prevBtn) { var t = trackFor(prevBtn); if (t) scrollByCards(t, -1); return; }
    if (nextBtn) { var t2 = trackFor(nextBtn); if (t2) scrollByCards(t2, 1); return; }

    /* add-to-cart "+" — delegated */
    var addBtn = e.target.closest('[data-fs-pop-add]');
    if (!addBtn) return;
    e.preventDefault();
    e.stopPropagation();
    if (addBtn.classList.contains('is-loading')) return;
    addBtn.classList.add('is-loading');
    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.add('fs-cart-loading'); /* show drawer loader during add */
    var body = {
      items: [{ id: addBtn.getAttribute('data-variant-id'), quantity: 1 }],
      sections: ['cart-drawer'],
      sections_url: window.location.pathname,
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(json);
        }
        updateCartCounts(json);
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: json }));
        addBtn.classList.remove('is-loading');
        if (drawer) drawer.classList.remove('fs-cart-loading');
      })
      .catch(function () {
        addBtn.classList.remove('is-loading');
        if (drawer) drawer.classList.remove('fs-cart-loading');
      });
  });

  /* arrow disabled-state — scroll doesn't bubble, so listen in the CAPTURE phase on document
     (fires for any descendant scroll). Works for every track, present or re-rendered. */
  document.addEventListener(
    'scroll',
    function (e) {
      var t = e.target;
      if (!t || !t.classList) return;
      if (t.classList.contains('fs-cart-popular__track')) updateArrows(t);
    },
    true
  );

  /* Keep every cart-count badge (header bubble + bottom mobile sticky toolbar) in sync on ANY cart
     change — Ella's PDP add (product-form.js) re-renders the drawer but doesn't touch the toolbar
     count, so the bottom number went stale. Refresh on the cart:updated event it publishes, plus
     a short delayed pass after the section re-render settles. */
  function refreshCounts() { updateCartCounts(); }
  document.addEventListener('cart:updated', function () { refreshCounts(); setTimeout(refreshCounts, 300); refreshScrollbar(); });
  /* drawer opens without a cart change — set up the scrollbar when the cart icon is clicked */
  document.addEventListener('click', function (e) {
    if (e.target.closest('.cart-icon--drawer, [data-cart-icon], .cart-icon, [href$="/cart"]')) {
      setTimeout(refreshScrollbar, 380);
    }
  });
  /* product-form / quick-add use the PUB_SUB cartUpdate channel; mirror it via a DOM event too */
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refreshCounts, 250); }); } catch (e) {}
  }

  /* set initial arrow state whenever a track (re)appears. Delegated clicks above always work;
     this only refreshes the prev/next disabled styling. Re-run on load + after cart re-renders. */
  function initTracks() {
    document.querySelectorAll('.fs-cart-popular__track').forEach(updateArrows);
  }
  if (document.readyState !== 'loading') initTracks();
  else document.addEventListener('DOMContentLoaded', initTracks);
  document.addEventListener('cart:updated', function () { setTimeout(initTracks, 50); });
  /* the cart drawer re-renders without firing cart:updated on the slider path, so also refresh
     shortly after any add click resolves */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-fs-pop-add]')) setTimeout(initTracks, 400);
  });
})();
